"use strict";
import { useTranslation } from "react-i18next";
import { Text } from "ui/src";
import { iconSizes } from "ui/src/theme";
import { WalletBaseOptionItem } from "components/lists/items/wallets/WalletBaseOptionItem";
import { AccountIcon } from "features/accounts/AccountIcon";
import { useENSAvatar, useENSName } from "features/ens/api";
import { getCompletedENSName } from "features/ens/useENS";
import { sanitizeAddressText } from "utils/addresses";
import { shortenAddress } from "utilities/src/addresses";
export function ENSAddressOptionItem({ ensAddressOption, onPress }) {
  const { t } = useTranslation();
  const { address, ensName, primaryENSName: savedPrimaryENSName, isRawName } = ensAddressOption;
  const formattedAddress = sanitizeAddressText(shortenAddress(address));
  const completedENSName = isRawName ? ensName : getCompletedENSName(ensName ?? null);
  const { data: fetchedPrimaryENSName, isLoading: isFetchingPrimaryENSName } = useENSName(
    savedPrimaryENSName ? void 0 : address
  );
  const primaryENSName = savedPrimaryENSName ?? fetchedPrimaryENSName;
  const isPrimaryENSName = completedENSName === primaryENSName;
  const showOwnedBy = !isFetchingPrimaryENSName && !isPrimaryENSName;
  const showAddress = !showOwnedBy;
  const { data: avatar } = useENSAvatar(address);
  return <WalletBaseOptionItem
    option={ensAddressOption}
    image={<AccountIcon address={address} avatarUri={avatar} size={iconSizes.icon40} />}
    title={(completedENSName || formattedAddress) ?? ""}
    subtitle={<Text color="$neutral2" ellipsizeMode="tail" numberOfLines={1} variant="subheading2">
          {showOwnedBy && t("explore.search.label.ownedBy", {
      ownerAddress: primaryENSName || formattedAddress
    })}
          {showAddress && formattedAddress}
        </Text>}
    onPress={onPress}
  />;
}
